import { render } from "./TemplatesAndThemes.vue?vue&type=template&id=528164b7"
import script from "./TemplatesAndThemes.vue?vue&type=script&lang=js"
export * from "./TemplatesAndThemes.vue?vue&type=script&lang=js"

import "./TemplatesAndThemes.vue?vue&type=style&index=0&id=528164b7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__